import { createSlice } from '@reduxjs/toolkit';
import { ProductsUpdateStateType } from '../../types/productsUpdate';

const initialState: ProductsUpdateStateType = {
    loading: false,
    loadingMultiple: false
};
export const productsUpdateSlice = createSlice({
    name: 'productsUpdate',
    initialState,
    reducers: {
        patchProductFetch: (state, action) => {
            state.loading = true;
        },
        patchProductFetchSuccess: (state) => {
            state.loading = false;
        },
        patchProductFetchFailure: (state, action) => {
            state.loading = false;
        },
        patchMultipleProductsFetch: (state, action) => {
            state.loadingMultiple = true;
        },
        patchMultipleProductsFetchSuccess: (state) => {
            state.loadingMultiple = false;
        },
        patchMultipleProductsFetchFailure: (state, action) => {
            state.loadingMultiple = false;
        }
    }
});

export const {
    patchProductFetch,
    patchProductFetchSuccess,
    patchProductFetchFailure,
    patchMultipleProductsFetch,
    patchMultipleProductsFetchSuccess,
    patchMultipleProductsFetchFailure,
} = productsUpdateSlice.actions;

export default productsUpdateSlice.reducer;
